module.exports = __webpack_public_path__ + "static/fri-56452b1b006b41ef792c66ea26cc2558.png";